import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNavigation from './TopNavigation';
import styled from 'styled-components';

const PageContainer = styled.main`
  width: min(100%, 1320px);
  margin: 0 auto;
  padding: calc(${props => props.theme.ui.navHeight} + clamp(1rem, 3vw, 2.5rem)) clamp(1rem, 3vw, 2.5rem) clamp(1rem, 3vw, 2.5rem);
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;

`;

const PageLayout = () => {
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <TopNavigation />
      <PageContainer id="main-content">
        <Outlet />
      </PageContainer>
    </>
  );
};

export default PageLayout;